/**
 * useEventsInRange Hook
 *
 * Hook para buscar eventos em um intervalo de tempo
 */

import { useQuery } from '@tanstack/react-query';
import { calendarService } from '../services/calendarService';

export const useEventsInRange = (
  startTime: string,
  endTime: string,
  userId?: string,
  statuses?: string[]
) => {
  const statusKey = statuses?.join(',') ?? '';
  return useQuery({
    queryKey: ['calendar-events-range', startTime, endTime, userId, statusKey],
    queryFn: () => calendarService.getEventsInRange(startTime, endTime, userId, statuses),
    staleTime: 2 * 60 * 1000, // 2 minutes
    enabled: !!(startTime && endTime),
  });
};
